module.exports = __webpack_public_path__ + "img/Cookie_1_resize_48.fcd74049.png";